import { Box } from 'braid-design-system';

const Panel = ({ children }: any) => (
  <Box paddingX="gutter" paddingTop={['large', 'xlarge']} paddingBottom="large">
    {children}
  </Box>
);

export default Panel;
